<div class="import-uses-values-table-container" style="overflow-y: auto">
    <div *ngIf="zoningCodesValidationData$ | async as zoningCodesValidationData" class="wrap">
        <div class="table flex column">
            <div class="row header flex align-centre">
                <div class="cell flex center column-municipality-name">Municipality Name</div>
                <div class="cell flex center column-municipality-description">Municipality Description</div>
                <div class="cell flex center column-gridics-jurisdiction-id">Gridics Jurisdiction Id</div>
                <div class="cell flex center column-parcel-layer">Parcel Layer</div>
                <div class="cell flex center column-index-state-layer">Index State Layer</div>
                <div class="cell flex center column-latitude">Latitude</div>
                <div class="cell flex center column-longitude">Longitude</div>
                <div class="cell flex center column-gridics-instance">Gridics Instance</div>
                <div class="cell flex center column-gridics-id">Gridics Id</div>
                <div class="cell flex center column-additional-place-ids">Additional Place Ids</div>
                <div class="cell flex center column-title">Title</div>
                <div class="cell flex center column-zoning-regulation-name">Zoning Regulation Name</div>
                <div class="cell flex center column-zoning-regulation-link">Zoning Regulation Link</div>
                <div class="cell flex center column-zoning-code-description">Zoning Code Description</div>
                <div class="cell flex center column-priority">Priority</div>
                <div class="cell flex center column-unit-system">Unit System</div>
                <div class="cell flex center column-create-all-zones">Create All Zones</div>
                <div class="cell flex center column-modules">Modules</div>

            </div>
            <div class="row body flex" *ngFor="let zcRow of zoningCodesRows$ | async; let i = index">
                <div class="cell flex align-center between column-municipality-name"
                    [ngClass]="{'red-text': !zcRow?.zoningCode?.importValidationResult?.isMunicipalityMatch, 'blue-text': zcRow?.zoningCode?.importValidationResult?.isMunicipalityMatch && !zcRow?.municipality?.importValidationResult?.isNew}">
                    {{zcRow?.municipality?.Name}}
                </div>
                <div class="cell flex align-center between column-municipality-description"
                    [ngClass]="{'red-text': !zcRow?.municipality?.importValidationResult?.isDescriptionMatch}">
                    {{zcRow?.municipality?.Description}}
                </div>
                <div class="cell flex align-center between column-gridics-jurisdiction-id"
                    [ngClass]="{'red-text': !zcRow?.municipality?.importValidationResult?.isGridicsIdMatch}">
                    {{zcRow?.municipality?.GridicsId}}
                </div>
                <div class="cell flex align-center between column-parcel-layer"
                    [ngClass]="{'red-text': !zcRow?.municipality?.importValidationResult?.isProjectsDataSourceCategoryMatch}">
                    {{zcRow?.municipality?.parcelLevel}}
                </div>
                <div class="cell flex align-center between column-index-state-layer"
                    [ngClass]="{'red-text': !zcRow?.municipality?.importValidationResult?.isIndexStateLayerPRsMatch}">
                    {{zcRow?.municipality?.IndexStateLayerPRs}}
                </div>
                <div class="cell flex align-center between column-latitude"
                    [ngClass]="{'red-text': !zcRow?.municipality?.importValidationResult?.isLatitudeMatch}">
                    {{zcRow?.municipality?.Latitude}}
                </div>
                <div class="cell flex align-center between column-longitude"
                    [ngClass]="{'red-text': !zcRow?.municipality?.importValidationResult?.isLongitudeMatch}">
                    {{zcRow?.municipality?.Longitude}}
                </div>
                <div class="cell flex align-center between column-gridics-instance"
                    [ngClass]="{'red-text': !zcRow?.municipality?.importValidationResult?.isGridicsInstanceDefined}">
                    {{zcRow?.gridicsInstance?.Name}}
                </div>
                <div class="cell flex align-center between column-gridics-id"
                    [ngClass]="{'red-text': !zcRow?.zoningCode?.importValidationResult?.isGridicsIdMatch}">
                    {{zcRow?.zoningCode?.GridicsId}}
                </div>
                <div class="cell flex align-center between column-additional-place-ids"
                    [ngClass]="{'red-text': !zcRow?.zoningCode?.importValidationResult?.isAdditionalPlaceIdsMatch}">
                    {{zcRow?.zoningCode?.AdditionalPlaceIds}}
                </div>
                <div class="cell flex center align-center row-name column-title"
                    [ngClass]="{'red-text': !zcRow?.zoningCode?.importValidationResult?.isValid, 'blue-text': zcRow?.zoningCode?.importValidationResult?.isValid && !zcRow?.zoningCode?.importValidationResult?.isNew}">
                    {{zcRow?.zoningCode?.Name}}
                </div>
                <div class="cell flex align-center between column-zoning-regulation-name"
                    [ngClass]="{'red-text': !zcRow?.zoningCode?.importValidationResult?.isZoningRegulationNameMatch}">
                    {{zcRow?.zoningCode?.ZoningRegulationName}}
                </div>
                <div class="cell flex align-center between column-zoning-regulation-link"
                    [ngClass]="{'red-text': !zcRow?.zoningCode?.importValidationResult?.isZoningRegulationLinkMatch}">
                    {{zcRow?.zoningCode?.ZoningRegulationLink}}
                </div>
                <div class="cell flex align-center between column-zoning-code-description"
                    [ngClass]="{'red-text': !zcRow?.zoningCode?.importValidationResult?.isDescriptionMatch}">
                    {{zcRow?.zoningCode?.Description}}
                </div>
                <div class="cell flex align-center between column-priority"
                    [ngClass]="{'red-text': !zcRow?.zoningCode?.importValidationResult?.isPriorityMatch}">
                    {{zcRow?.zoningCode?.Priority}}
                </div>
                <div class="cell flex align-center between column-unit-system"
                    [ngClass]="{'red-text': !zcRow?.zoningCode?.importValidationResult?.isUnitSystemMatch}">
                    {{zcRow?.zoningCode?.unitSystemStr}}
                </div>
                <div class="cell flex align-center between column-create-all-zones">
                    {{zcRow?.zcCreateAllZones}}
                </div>
                <div class="cell flex align-center between column-modules"
                    [ngClass]="{'red-text': getIsCorrectModules(zcRow)}">{{zcRow?.modulesStr}}
                </div>

            </div>
        </div>
    </div>
</div>
<div>
    <mat-toolbar>
        <div class="footer-buttons-container">
            <app-download-zoning-code-import-template
                [templateType]="'ZONING_CODE'"
                style="margin-right: 30px;"></app-download-zoning-code-import-template>
            <zc-validation-icon *ngIf="zoningCodesValidationData$ | async as zoningCodesValidationData" class="zc-validation-icon green"
                style="margin-right: 10px;"
                [zoningCodesImportValidationResult]="zoningCodesValidationData"></zc-validation-icon>
            <button mat-raised-button color="primary" (click)="openDialog()">Upload File</button>
            <button mat-raised-button color="primary" (click)="importData()" [disabled]="!canImport">Import</button>
            <button *ngIf="showValidateButton" mat-raised-button (click)="validateZC()">Validate</button>
            <button mat-raised-button (click)="clearUsesTable()">Clear</button>
        </div>
    </mat-toolbar>
</div>
